module.exports = __webpack_public_path__ + "img/live-cover.70df227d.png";